import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA, MatDialog,
  MatDialogConfig, MatDialogRef
} from '@angular/material/dialog';
import { NoteDetails, NoteDetailsFragment, NoteTarget } from 'generated/graphql';

export interface NoteEditDialogData {
  targetId: string;
  targetType: NoteTarget;
  note: NoteDetails.Fragment;
  notes?: any;
}
@Component({
  selector: 'app-note-edit-dialog-component',
  template: `<div class="modal">
    <div class="modal__body modal__body">
        <i class="fal fa-times modal__close" (click)="close(null)" data-test-id="closeNoteDialogBtn"></i>
        <h1 class="h2">{{getTitleText(data.note)}} </h1>
        <div class="vert-0050">
            <app-note-edit
            [targetType]="data.targetType"
            [targetId]="data.targetId"
            (noteSaved)="_onNoteSaved($event)"
            (canceled)="close(null)"
            [note]="data.note" class="modal__padding"></app-note-edit>
        </div>
    </div>
</div>`
})
export class NoteEditDialog {
  static open(dialog: MatDialog, config: MatDialogConfig<NoteEditDialogData>) {
    return dialog.open(NoteEditDialog, config);
  }

  constructor(
    public dialogRef: MatDialogRef<NoteEditDialog>,
    @Inject(MAT_DIALOG_DATA)
    public data: NoteEditDialogData) { }

  close(result?: any) {
    this.dialogRef.close(result);
  }

  getTitleText(note: NoteDetailsFragment) {
    if (this.data.targetType === NoteTarget.FollowUp) {
      return 'Edit follow-up Flag Note';
    }
    switch (note.noteType) {
      case 'date':
        return 'Update Date';
      case 'number':
        return 'Update Number';
      default:
        return 'Update Note';
    }
  }

  /**
   * Internal to pass event up
   *
   * @param event
   */
  _onNoteSaved(event: NoteDetailsFragment) {
    this.close(event);
  }
}
